import type {Persistor} from "redux-persist";

/**
 * Access to the redux-persist persistor from non-React code (axios interceptors).
 *
 * The persistor is created in `src/index.tsx` because it needs the browser
 * storage; importing it from a module that is itself imported by the store would
 * create a cycle (and would run `persistStore` inside unit tests that only need
 * the reducers).
 */
let current: Persistor | null = null;

export const setPersistor = (persistor: Persistor | null): void => {
    current = persistor;
};

/**
 * Resolves once redux-persist has written the current state to storage. Used
 * before a full page navigation (expired session) so the cleared session is not
 * raced by an unload that happens before the debounced write.
 */
export const flushPersistedState = async (): Promise<void> => {
    try {
        await current?.flush();
    } catch (error) {
        // Persisting is best-effort: never block the logout on a storage error.
    }
};
